import React, { useContext } from "react";
import PageBanner from "../components/PageBanner";
import { LanguageContext } from "../LanguageContext"; // Import the context

const About = () => {
  const { language } = useContext(LanguageContext); // Use the context
  // Text content for English and Arabic
  const text = {
    en: {
      aboutUS: "About Us",
      atOneFureverWeArePassionateAboutBuilding:
        "At OneFurever, we are passionate about building a community where pets are safe, loved, and connected with the right people. Our platform is designed to make pet care easier by offering essential services that help pet owners and animal lovers take action when it matters most.",
      whetherYouAreLookingToAdoptApet:
        "Whether you're looking to adopt a pet, rescue an animal in need, or reunite with a lost furry friend, OneFurever provides a simple and reliable way to connect with others who share the same goal, ensuring pets find the care and companionship they deserve.",
      beyondAdoptionAndRescueWeAlsoBelieve:
        "Beyond adoption and rescue, we also believe in the power of socialization for pets. Our Playtime feature allows pet owners to arrange meetups, giving their furry companions the opportunity to bond, exercise, and enjoy new experiences in a safe environment.",
      atOneFureverWeKnowThatEveryPetIsJourneyIsUnique:
        "At OneFurever, we know that every pet’s journey is unique, and we’re here to support each step along the way. Join us in creating a world where every pet has the chance to live happily and safely, because when it comes to pets, love is furever.",
    },
    ar: {
      aboutUS: "نبذة عنا",
      atOneFureverWeArePassionateAboutBuilding:
        "في  وان فوريفر، نحرص على بناء مجتمع آمن ومحب للحيوانات الأليفة، حيث تتواصل مع الأشخاص المناسبين. صُممت منصتنا لتسهيل رعاية الحيوانات الأليفة من خلال تقديم خدمات أساسية تُساعد مالكي الحيوانات الأليفة ومحبيها على اتخاذ الإجراءات اللازمة عند الحاجة.",
      whetherYouAreLookingToAdoptApet:
        "سواء كنت ترغب في تبني حيوان أليف، أو إنقاذ حيوان محتاج، أو لمّ شمله مع حيوان أليف مفقود، فإن وان فوريفر تُوفر طريقة بسيطة وموثوقة للتواصل مع الآخرين الذين يشاركونك نفس الهدف - لضمان حصول حيواناتك الأليفة على الرعاية والرفقة التي تستحقها.",
      beyondAdoptionAndRescueWeAlsoBelieve:
        "إلى جانب التبني والإنقاذ، نؤمن أيضًا بأهمية التنشئة الاجتماعية للحيوانات الأليفة. تتيح ميزة \"وقت اللعب\" لمالكي الحيوانات الأليفة ترتيب لقاءات، مما يمنح حيواناتهم الأليفة فرصة الترابط وممارسة الرياضة والاستمتاع بتجارب جديدة في بيئة آمنة.",
      atOneFureverWeKnowThatEveryPetIsJourneyIsUnique:
        "في  وان فوريفر، نُدرك أن رحلة كل حيوان أليف فريدة، ونحن هنا لدعم كل خطوة على طول الطريق. انضم إلينا في بناء عالم يتمتع فيه كل حيوان أليف بفرصة العيش بسعادة وأمان، لأنه عندما يتعلق الأمر بالحيوانات الأليفة، فإن الحب يدوم للأبد.",
    },
  };
  return (
    <>
      <PageBanner />
      <div className={`container pt-5 ${language === "ar" ? "rtl" : ""}`}>
        <div className=" row ">
          <div className="privacy-main-header">{text[language].aboutUS}</div>
          <p className="privacy-content">
            {text[language].atOneFureverWeArePassionateAboutBuilding}
          </p>
          <p className="privacy-content">
            {text[language].whetherYouAreLookingToAdoptApet}
          </p>

          <p className="privacy-content">
            {text[language].beyondAdoptionAndRescueWeAlsoBelieve}
          </p>
          <p className="privacy-content">
            {text[language].atOneFureverWeKnowThatEveryPetIsJourneyIsUnique}
          </p>
        </div>
      </div>
    </>
  );
};

export default About;
